module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isOpen) ? _c('div', {
    staticClass: "novo-valor-input-container"
  }, [_vm._v("\n  Insira o novo valor para o lance\n  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valorFormatado),
      expression: "valorFormatado"
    }, {
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }],
    ref: "input",
    attrs: {
      "placeholder": "R$ 0,00",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.valorFormatado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valorFormatado = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "botoes-acao-novo-valor-lance"
  }, [_c('button', {
    staticClass: "btn bg-primary",
    on: {
      "click": _vm.confirmaValor
    }
  }, [_vm._v("Confirmar")]), _vm._v(" "), _c('button', {
    staticClass: "btn bg-danger",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancelar")])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-783ef482","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/AlterarValorLance.vue
// module id = 828
// module chunks = 2